﻿export enum StatisticSentiment {
    Positive = "Positive",
    Negative = "Negative",
    Neutral = "Neutral"
}